
define("rv!templates/layout/footer",[],function(){return { v:3,
  t:[ { t:7,
      e:"div",
      a:{ style:"background-color:#f4f4f4;border-top:2px solid #eee;padding:20px;padding-top:0px;padding-bottom:5px;width:AUTO;" },
      f:[ { t:7,
          e:"br",
          a:{ "class":"clear" } },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"Destinations" },
          f:[ { t:7,
              e:"a",
              a:{ href:"/#/destinations" },
              f:[ { t:7,
                  e:"img",
                  a:{ src:"https://adestinn2blob.blob.core.windows.net/images/footer/destinationsicon.jpg",
                    alt:"" } } ] },
            " ",
            { t:7,
              e:"a",
              a:{ href:"/#/destinations",
                "class":"footerLinkNew" },
              f:[ "Destinations" ] } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"separator" } },
        " ",
        { t:7,
          e:"a",
          a:{ title:"Click for the Business Review of Adestinn, LLC, an Employee Benefit Plans in Saint Paul MN",
            style:"float:right;",
            target:"_blank",
            href:"http://www.bbb.org/minnesota/business-reviews/employee-benefit-plans/adestinn-in-saint-paul-mn-96319539#sealclick",
            "data-track":"footer,Better_Business_Bureau,click,1" },
          f:[ { t:7,
              e:"img",
              a:{ alt:"Click for the BBB Business Review of this Employee Benefit Plans in Saint Paul MN",
                style:"border: 0;",
                src:"https://adestinn2blob.blob.core.windows.net/images/footer/bbb.png" } } ] },
        " ",
        { t:7,
          e:"span",
          a:{ id:"siteseal",
            style:"float:right;margin-right:20px;" },
          f:[ { t:7,
              e:"script",
              a:{ async:0,
                type:"text/javascript",
                src:"https://seal.godaddy.com/getSeal?sealID=vqiy7Bmju1zPjvZ6VjzJkrmW2sCPBJJfHTh4NAvHI8mq7i2LJtuhG50qPZK3" } } ] },
        " ",
        { t:7,
          e:"a",
          a:{ href:"#usBankPop",
            "class":"infoLink",
            style:"float:right;",
            "data-track":"footer,usbank,click,1" },
          f:[ { t:7,
              e:"img",
              a:{ style:"margin-right:20px;",
                src:"https://adestinn2blob.blob.core.windows.net/images/footer/usbanknew.png",
                alt:"USBank" } } ] },
        " ",
        { t:7,
          e:"div",
          a:{ id:"usBankPop",
            style:"display:none;padding:20px;" },
          f:[ { t:7,
              e:"strong",
              f:[ "Your funds are held in a custodial account at USBank." ] } ] },
        " ",
        { t:7,
          e:"img",
          a:{ style:"margin-right:20px;float:right;",
            src:"https://adestinn2blob.blob.core.windows.net/images/footer/fdicnew.png",
            alt:"FDIC",
            "data-track":"footer,FDIC,nonClickable,0" } },
        " ",
        { t:7,
          e:"br",
          a:{ "class":"clear" } },
        " ",
        { t:7,
          e:"hr",
          a:{ style:"margin:0px;width:AUTO;margin-left:-20px;" } },
        " ",
        { t:7,
          e:"div",
          a:{ style:"padding-top:10px;padding-bottom:0px;float:right;font-size:11px;color:#666;" },
          f:[ "© ",
            { t:2,
              x:{ r:[ "getYear" ],
                s:"_0()" } },
            " Adestinn, LLC  Minneapolis, MN | ",
            { t:2,
              r:"ServerData.Phones.MemberSupportPhone" },
            " | ",
            { t:7,
              e:"a",
              a:{ href:"/#/contact" },
              f:[ "Contact Member Support" ] },
            " | ",
            { t:7,
              e:"a",
              a:{ href:"/#/privacy-policy" },
              f:[ "Privacy and Security Policy" ] },
            " | ",
            { t:7,
              e:"a",
              a:{ href:"/#/terms-of-use" },
              f:[ "Terms of Use" ] },
            " | ",
            { t:7,
              e:"a",
              a:{ href:"/#/HR/?tr=footer" },
              f:[ "Sales Inquiries" ] },
            " | ",
            { t:7,
              e:"a",
              a:{ href:"#",
                "class":"openOlark" },
              f:[ "Feedback" ] } ] },
        " ",
        { t:7,
          e:"br",
          a:{ "class":"clear" } } ] } ] };});
